import React from "react";
import { Link } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import PaginationView from "components/table/Pagination";
import store from "redux/store";
import { SHOW_MODAL } from "actions/types";
import { useTranslation } from "react-i18next";

export function Overview(props) {
  const { t, i18n } = useTranslation("productview");
  const [open, setOpen] = React.useState(false);

  const changeStateModal = (event, itemObj) => {
    event.preventDefault();
    event.stopPropagation();
    store.dispatch({
      type: SHOW_MODAL,
      message: "",
      header: "Product status",
      data: itemObj,
      saveEvent: props.storeNewStateForProductEvent,
    });
    return false;
  };

  const toggleRowShow = (event, item) => {
    event.preventDefault();
    if (open === item.id + "open") {
      setOpen(false);
    } else {
      setOpen(item.id + "open");
    }
  };

  const getStatusColorClass = (stateType) => {
    const stateTypeLower = stateType.toLowerCase();
    switch (stateTypeLower) {
      case "active":
        return "bg-green-50 text-green-800";
      case "sold":
        return "bg-blue-50 text-blue-800";
      case "reserved":
        return "bg-yellow-50 text-yellow-800";
      case "inactive":
        return "bg-gray-50 text-gray-800";
      default:
        return "bg-gray-50 text-gray-800";
    }
  };

  return (
    <>
      <div className="mb-4 md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
            Mijn advertenties
          </h2>
        </div>
        <div className="flex gap-2 mt-0 md:ml-4">
          <Link to="/products/add" className="btn-primary">
            Advertentie toevoegen
          </Link>
        </div>
      </div>

      <div className="flow-root mt-8">
        <div className="overflow-x-auto -mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div className="inline-block py-2 min-w-full align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="py-3.5 pr-3 pl-4 text-sm font-semibold text-left text-gray-900 sm:pl-0"
                  >
                    Naam
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-sm font-semibold text-left text-gray-900 lg:table-cell"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-sm font-semibold text-left text-gray-900 lg:table-cell"
                  >
                    Prijs
                  </th>
                  <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-0">
                    <span className="sr-only">Acties</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {props.items.map((item) => (
                  <tr key={item.id}>
                    <td className="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0">
                      <Link
                        to={`/products/edit/${item.id}`}
                        className="font-medium text-primary hover:underline"
                      >
                        {item.name}
                      </Link>
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 whitespace-nowrap lg:table-cell">
                      <span
                        className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${getStatusColorClass(
                          item.stateType
                        )}`}
                      >
                        {t("productview.tablevalue.state_" + item.stateType)}
                      </span>
                    </td>
                    <td className="hidden px-3 py-4 text-sm font-medium text-gray-900 whitespace-nowrap lg:table-cell">
                      €{item.price}
                    </td>
                    <td className="relative py-4 pr-4 pl-3 text-sm font-medium text-right whitespace-nowrap sm:pr-0">
                      <Menu
                        as="div"
                        className="inline-block relative text-left"
                      >
                        <div>
                          <MenuButton className="flex gap-2 items-center btn-secondary">
                            Meer
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="-mr-1 text-gray-400 size-4"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M20 9L12 17L4 9"
                                stroke="currentColor"
                                strokeWidth="2"
                              />
                            </svg>
                          </MenuButton>
                        </div>
                        <MenuItems
                          transition
                          className="absolute right-0 z-10 mt-2 w-56 origin-top-right bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                          <div className="py-1">
                            <MenuItem>
                              <Link
                                to={`/products/edit/${item.id}`}
                                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="text-gray-500"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                </svg>
                                Advertentie bewerken
                              </Link>
                            </MenuItem>
                            <MenuItem>
                              <button
                                onClick={(event) =>
                                  changeStateModal(event, item)
                                }
                                className="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="text-gray-500"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                                  />
                                </svg>
                                Status wijzigen
                              </button>
                            </MenuItem>
                          </div>
                        </MenuItems>
                      </Menu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PaginationView
        pagingEventHandler={props.pagingEventHandler}
        pagination={props.pagination}
      />
    </>
  );
}
